import React from 'react';
import CardFrame from './atoms/CardFrame';

const TopSellersRankingSkeleton: React.FC = () => (
    <CardFrame className="w-full">
      <div className="flex flex-col gap-3 animate-pulse">
        <div className="h-5 w-40 rounded bg-neutral-200 dark:bg-neutral-700" />
        <ul className="flex flex-col gap-2">
          {[...Array(5)].map((_, index) => (
            <li
              key={index}
              className="flex items-center justify-between rounded-lg px-3 py-2 border-x-4 border-y border-border-tertiary"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="h-4 w-6 rounded bg-neutral-200 dark:bg-neutral-700 shrink-0" />
                <div className="h-4 w-40 rounded bg-neutral-200 dark:bg-neutral-700" />
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <div className="h-4 w-12 rounded bg-neutral-200 dark:bg-neutral-700" />
                <div className="h-4 w-8 rounded bg-neutral-200 dark:bg-neutral-700" />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </CardFrame>
);

export default TopSellersRankingSkeleton;
